import { styled } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';

import { LANG } from '../../../services/Config.js';

const LogoContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  paddingTop: '15%',
  display: 'flex',
  justifyContent: 'center',
  width: '50%',
  [theme.breakpoints.up('sm')]: {
    paddingTop: '10%',
    width: '33.33%',
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: '5%',
    width: '20%',
  },
}));

const LogoContainerLink = styled(RouterLink)(({ theme }) => ({
  position: 'relative',
  paddingTop: '15%',
  display: 'flex',
  justifyContent: 'center',
  width: '50%',
  [theme.breakpoints.up('sm')]: {
    paddingTop: '10%',
    width: '33.33%',
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: '5%',
    width: '20%',
  },
}));

const LogoImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'big',
})<{ big?: boolean }>(({ theme, big }) => ({
  // position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: 'auto',
  maxHeight: big ? 70 : 30,
  maxWidth: '60%',
  [theme.breakpoints.up('sm')]: {
    maxHeight: big ? 80 : 40,
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '80%',
  },
}));

interface PartnerBankImageProps {
  item: any;
  variant?: 'unicolored' | 'multicolored';
  isLink?: boolean;
}

const PartnerBankImage = ({
  item,
  variant = 'unicolored',
  isLink = false,
}: PartnerBankImageProps) => {
  const logoColorVariant = variant === 'unicolored' ? 0 : 1;
  const { appStrings } = LANG;

  return isLink ? (
    <LogoContainerLink
      key={item.key}
      to={routes.ERROR_PAGE}
      // to={
      //   generatePath(routes.PARTNER_BANK_DETAILS, {
      //     bankKey: item.key,
      //   }) || null
      // }
      aria-label={`${item.key} ${appStrings.DETAILS_PAGE}`}
    >
      <LogoImage
        src={item.src[logoColorVariant]}
        alt={`${item.key} logo`}
        big={item && item.key === 'bankNorwegian'}
        loading="lazy"
      />
    </LogoContainerLink>
  ) : (
    <LogoContainer key={item.key}>
      <LogoImage
        src={item.src[logoColorVariant]}
        alt={`${item.key} logo`}
        big={item && item.key === 'bankNorwegian'}
        loading="lazy"
      />
    </LogoContainer>
  );
};

export default PartnerBankImage;
